<template>
  <div v-if="overviewInfo" class="dashboard-page-cont product-manage">
    <div class="product-manage-head">
      <span class="model-title">产品管理</span>
      <a class="model-more" :href="onlineUrl + '/saas-topping/product-manage-list'">查看全部 <i class="el-icon-arrow-right"></i></a>
    </div>
    <div class="product-manage-cont">
      <div class="cont-item">
        <div class="cont-item-link">
          <span class="cont-label">产品总数</span>
          <p class="cont-value">{{ overviewInfo.productCount | valueFormat }}</p>
        </div>
      </div>
      <div class="cont-item">
        <div class="cont-item-link">
          <span class="cont-label">已上架</span>
          <p class="cont-value">{{ overviewInfo.productOnShelfCount | valueFormat }}</p>
        </div>
      </div>
      <div class="cont-item">
        <div class="cont-item-link">
          <span class="cont-label">已下架</span>
          <p class="cont-value">{{ overviewInfo.productOffShelfCount | valueFormat }}</p>
        </div>
      </div>
      <div class="cont-item">
        <div class="cont-item-link">
          <span class="cont-label">草稿</span>
          <p class="cont-value">{{ overviewInfo.productDraftCount | valueFormat }}</p>
        </div>
      </div>
      <a :href="onlineUrl + '/saas-topping/category-linking?type=add'" class="publish-product">
        <i class="iconfont icon-fabushangpin"></i>
        <p class="publish-text">发布产品</p>
      </a>
    </div>
  </div>
</template>

<script>
import { getProductManageState } from '@/utils/api/dashboard';
import { onlineUrl } from '@/utils/config';

export default {
  name: 'ProductManage',
  data() {
    return {
      onlineUrl,
      overviewInfo: null,
    }
  },
  methods: {
    getProductManageState() {
      getProductManageState()
      .then(res=> {
        if(res.rspResult.bizCode == 200) {
          this.overviewInfo = res.data || null;  //匹配询盘
        }
      })
      .catch(err=> {
        console.error('获取产品状态统计出错', err)
      })
    }
  },
  created() {
    this.getProductManageState();
  }
}
</script>

<style lang="scss" scoped>
.product-manage {
  background-color: #fff;
  padding: 20px;
  font-family: SourceHanSansCN-Regular;
  &-head {
    display: flex;
    .model-more {
      margin-left: auto;
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #16181A;
      letter-spacing: 0;
    }
  }
  &-cont {
    display: flex;
    .cont-item {
      flex: 1;
      margin-left: 16px;
      box-sizing: border-box;
      padding: 16px 0 0 20px;
      &-link {
        display: block;
        width: fit-content;
      }
      .cont-label {
        font-size: 14px;
        color: #4F5D78;
        line-height: 22px;
        margin-bottom: 4px;
      }
      .cont-value {
        color: #16181A;
        font-weight: bold;
        font-family: Arial;
        font-size: 20px;
        line-height: 30px;
        width: fit-content;
      }
      &:nth-child(1) {
        margin-left: 0;
      }
    }
    .publish-product {
      width: 86px;
      height: 88px;
      background: #eff5ff;
      backdrop-filter: blur(20px);
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      color: #066EB7;
      padding-top: 19px;
      box-sizing: border-box;
      user-select: none;
      margin-left: 15px;
      flex-shrink: 0;
      position: relative;
      .iconfont {
        font-size: 24px;
        line-height: 24px;
      }
      .publish-text {
        line-height: 18px;
        margin-top: 8px;
      }
      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 100%;
        left: -16px;
        top: 0;
        border-left: 1px solid #CFD5DF;
        pointer-events: none;
      }
    }

  }
}
</style>